import { Navigate, Outlet, useParams } from "react-router-dom";
import localStorageService from "services/localStorageService";
import { AUTHORIZATION_INFO } from "@pga/utils/constance/constance";

export const ProtectedRoutes = () => {
  const isSignIn = localStorageService.get(AUTHORIZATION_INFO);
  const params = useParams();

  if (!isSignIn.accessToken) {
    return <Navigate to={`/kiosk/${params.id}/login`} replace />;
  }
  return <Outlet />;
};
